import { createSelector } from 'reselect';
import { getDocumentsById } from 'documents/store/documents/selectors';
import { getFoldersById } from 'documents/store/folders/selectors';

export const getDefaultFavoriteIds = state => state.defaultFavorites.ids;

export const getDefaultFavorites = createSelector(
  [getDocumentsById, getFoldersById, getDefaultFavoriteIds],
  (documents, folders, ids) => ids.map(id => documents[id] || folders[id]) || [],
);

export const getEditingDocumentDashboardIdsWithFavorite = state =>
  state.defaultFavorites.editingDocumentDashboardIdsWithFavorite.ids;

export const getEditingDocumentDashboardIdsWithFavoriteIsLoading = state =>
  state.defaultFavorites.editingDocumentDashboardIdsWithFavorite.isLoading;
